import React, { useContext } from "react";
import { CommandBarButton, Theme, useDisclosure } from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";
import { OrderDashboardContext } from "../../dashboard/provider/OrderDashboardContext";
import { CompleteRejectedOrderModal } from "../CompleteRejectedOrderModal";

export const CompleteRejectedOrderButton: React.VFC = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const { orderId, orderDashboardItem, isLoading, completeRejected } = useContext(OrderDashboardContext);

    const { status } = orderDashboardItem;

    const handleCompletion = async () => {
        completeRejected();

        onClose();
    };

    const isDisabled = isLoading || status !== OrderStatus.Rejected;

    return (
        <>
            <CompleteRejectedOrderModal
                isOpen={isOpen}
                onCancel={onClose}
                onSubmit={handleCompletion}
                orderId={orderId}
            />
            <CommandBarButton
                text="Complete"
                styles={{ root: { background: Theme.palette.neutralLighterAlt } }}
                disabled={isDisabled}
                icon="CheckboxComposite"
                onClick={onOpen}
                testId={"complete-rejected-order-button"}
            />
        </>
    );
};
